import classNames from "classnames";
import { TimePicker } from "PFComponents/calendar/time_picker";
import { Icon } from "PFComponents/icon";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CalendarForm } from "../../../calendars.types";
import css from "../dates.module.scss";
import { extractErrorMessage } from "./utils";
import { WorkingHours } from "./working_hours/working_hours";

type TimeSectionProps = {
  index: number;
  daysType: "nominalDays" | "exceptionDays";
  isDisabled: boolean;
};

export const TimeSection = ({ index, daysType, isDisabled }: TimeSectionProps): JSX.Element => {
  const { t } = useTranslation("bookingModule");
  const {
    watch,
    formState: { errors }
  } = useFormContext<CalendarForm>();

  const errorMessage = extractErrorMessage(index, errors, daysType);
  const hasError = Boolean(errorMessage);

  const [from, to] = watch([`${daysType}.${index}.startTime`, `${daysType}.${index}.endTime`]);

  return (
    <>
      <div
        className={classNames(css.timeSection, {
          [css.disabled]: isDisabled
        })}
      >
        <Icon size="sm" name="created" />
        <Controller
          name={`${daysType}.${index}.startTime`}
          render={({ field }) => (
            <TimePicker
              className={classNames(css.timePicker, { [css.inputError]: hasError })}
              disabled={isDisabled}
              onChange={field.onChange}
              value={field.value}
              max={to}
            />
          )}
        />
        {t("config.calendars.to")}
        <Controller
          name={`${daysType}.${index}.endTime`}
          render={({ field }) => (
            <TimePicker
              className={classNames(css.timePicker, { [css.inputError]: hasError })}
              disabled={isDisabled}
              onChange={field.onChange}
              value={field.value}
              min={from}
            />
          )}
        />
      </div>
      <WorkingHours index={index} daysType={daysType} isDisabled={isDisabled} />
    </>
  );
};
